import * as React from 'react';
import Table from '../../Containers/Dashboard/WhoIsOffToday/Table';
import ResponsiveModal from './ResponsiveModal';

export default class WhoIsOffToday extends ResponsiveModal {
    getContent() {
        return <Table rows={this.props.rows} showAll={true} />
    }
}